import { baseApi } from 'utils/apiUtil';
import { httpM } from 'utils/httpUtil';

const assistantInitializeURL = `${baseApi}/v2/assistant/initialize`;

export const initializeAssistant = async (
  benefitGuideId: string,
  employerId: string,
  organizationId: string
) => {
  try {
    const response = await httpM.post(assistantInitializeURL, {
      benefitGuideId: benefitGuideId,
      employerId: employerId,
      organizationId: organizationId,
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};
